// extracted by mini-css-extract-plugin
module.exports = {"image__container":"styles_image__container__1_v0T","image__view":"styles_image__view__1YuCh","image":"styles_image__TaigL","max__image":"styles_max__image__3ULNU"};